<form [formGroup]="form" class="input-grid-gaps grid-6col mt-1 user-employment-dialog">
    <div class="fr-3 input-grid-gaps grid-2col">
        <app-date-input [form]="form" timeType="startOfDay" id="dateFrom"></app-date-input>
        <app-date-input [form]="form" timeType="endOfDay" id="dateTo"></app-date-input>
    </div>
    <div class="fr-3">
        <app-employment-type-select-input [form]="form"/>
    </div>
    <div class="fr-2">
        <app-select-input
            id="service"
            [form]="form"
            label="user.editUser.inputs.employmentService"
            [staticOptions]="store.services()"
            valueKey="id">
        </app-select-input>
    </div>
    <div class="fr-2">
        <app-select-input
            id="contract"
            [form]="form"
            label="user.editUser.inputs.contract"
            [staticOptions]="contractOptions"
            valueKey="name">
            <ng-template #item let-data>
                {{ ('user.createUser.contracts.' + (data?.name ?? data)) | translate }}
            </ng-template>

            <ng-template #selectedItem let-data>
                @if (data) {
                    <span>{{ ('user.createUser.contracts.' + (data?.name ?? data)) | translate }}</span>
                } @else {
                    {{ 'user.createUser.jobInService' | translate }}
                }
            </ng-template>
        </app-select-input>
    </div>
    <div class="fr-2">
        <app-text-input id="specificName" label="user.editUser.inputs.specificName" [form]="form"></app-text-input>
    </div>
    @if (workloadVisible) {
        <div class="fr-3">
            <app-select-input
                id="workloadType"
                label="user.createUser.workloadType"
                [form]="form"
                [staticOptions]="workloadOptions"
                [autoDisplayFirst]="false"
                valueKey='name'>
                <ng-template #item let-data>
                    {{ ('user.common.workloadTypes.' + (data?.name ?? data)) | translate }}
                </ng-template>
                <ng-template #selectedItem let-data>
                    {{ ('user.common.workloadTypes.' + (data?.name ?? data)) | translate }}
                </ng-template>
            </app-select-input>
        </div>
        <div class="fr-3">
            <p-inputNumber
                formControlName="workloadSize"
                mode="decimal"
                [minFractionDigits]="1"
                [maxFractionDigits]="5"
                locale="cs"
                [placeholder]="'user.createUser.workloadSize' | translate"
                styleClass="w-full"
            />
        </div>
    }
    @if (scopeOfWorkVisible) {
        <div class="fr-3">
            <p-inputNumber
                formControlName="scopeOfWork"
                locale="cs"
                [placeholder]="'user.createUser.scopeOfWork' | translate"
                styleClass="w-full"
            />
        </div>
    }
    <p-card [header]="'user.editUser.labels.workplaces' | translate" class="fr-6">
        <div class="flex justify-content-end mb-2">
            <app-button icon="pi-plus" (clickEvent)="addWorkplace()"></app-button>
        </div>
        <div class="input-grid-gaps grid-3col" formArrayName="workplaces">
            @for (workplaceForm of workplacesControl.controls; track workplaceForm; let i = $index) {
                <app-date-input [form]="workplaceForm" timeType="startOfDay" id="w_dateFrom"
                    label="inputs.dateFrom"></app-date-input>
                <app-date-input [form]="workplaceForm" timeType="endOfDay" id="w_dateTo"
                    label="inputs.dateTo"></app-date-input>
                <div class="flex gap-small">
                    <app-select-input
                        id="workplaceId"
                        label="user.createUser.workplace"
                        [form]="workplaceForm"
                        [staticOptions]="workplaces"
                        valueKey="id"
                        [autoDisplayFirst]="false"
                        class="flex-1">
                    </app-select-input>
                    <app-delete-button [text]="true" [hideLabel]="true" confirmationType="none"
                        (clickEvent)="deleteWorkplace(i)"></app-delete-button>
                </div>
            }
        </div>
    </p-card>
    <div class="fr-6">
        <app-text-input id="note" label="user.editUser.inputs.note" [form]="form"></app-text-input>
    </div>
</form>
